import { render, staticRenderFns } from "./gridtable.vue?vue&type=template&id=768e2056"
import script from "./gridtable.vue?vue&type=script&lang=js"
export * from "./gridtable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports